import styled from "@emotion/styled";

export const ModalBody = styled.div`
  padding: 16px;
  max-height: 700px;
  overflow: auto;
`;
